import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    CardInventoryReduxState,
    CardInventoryResponse,
    VeCardInventorySliceEnum
} from 'storeTypes'
import { getCardInventory } from './cardActionHelpers'

export const veCardInventoryAction = createAsyncThunk<
    CardInventoryResponse[],
    string,
    { rejectValue: string }
>(
    VeCardInventorySliceEnum.VE_CARD_INVENTORY_ACTION_PREFIX,
    async (veCode: string, thunkAPI) => {
        const veCardInventory = await getCardInventory(veCode)

        if (typeof veCardInventory === 'string') {
            return thunkAPI.rejectWithValue(veCardInventory)
        }

        return veCardInventory
    }
)

const veCardInventoryInitialState: CardInventoryReduxState = {}

const veCardInventorySlice = createSlice({
    name: VeCardInventorySliceEnum.VE_CARD_INVENTORY_SLICE_NAME,
    initialState: veCardInventoryInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(veCardInventoryAction.pending, (state) => {
                state.loading = true
            })
            .addCase(
                veCardInventoryAction.fulfilled,
                (state, action: PayloadAction<CardInventoryResponse[]>) => {
                    state.loading = false
                    state.cardInventory = action.payload?.filter(
                        ({ cards_in_packet: cardsInPacket }) =>
                            cardsInPacket > 0
                    )
                }
            )
            .addCase(veCardInventoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })
    }
})

export const veCardInventoryReducer = veCardInventorySlice.reducer
